import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalContent,
  ModalFooter,
  ModalBody,
} from '@chakra-ui/react';

const EmailVerificationModal = (props) => {
  const { t } = useTranslation();
  const { isOpen, onClose, email = '' } = props;
  return (
    <Modal
      isOpen={isOpen}
      onOverlayClick={onClose}
      autoFocus={false}
      size="4xl"
      scrollBehavior="inside"
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        bgColor="primary.500"
        borderRadius="6px"
        mx="4"
        className="member-center-profile__email-verification-modal"
        color="#5b5b5b"
      >
        <ModalHeader
          className="member-center-profile__email-verification-modal-text"
          fontSize="16px"
        >
          {t('user.sign_up.email_verification.dialog.title', { email })}
        </ModalHeader>
        <ModalBody
          variant="default"
          className="member-center-profile__email-verification-modal-text"
          fontSize="14px"
        >
          {t('user.sign_up.email_verification.dialog.description')}
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={onClose}
            variant="fill"
            autoFocus={false}
            className="member-center-profile__email-verification-modal-button"
          >
            {t('user.sign_up.email_verification.dialog.confirm')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

EmailVerificationModal.propTypes = {
  email: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default EmailVerificationModal;
